export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: this.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 90,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'yarnNo',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_no') || '纱线编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_name') || '纱线名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnNameEn',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_name_en') || '纱线名称英文',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnContent',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_content') || '纱线成分中文',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnContentEn',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_content_en') || '纱线成分英文',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'categoryCode',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_category_code') || '分类名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'supName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_sup_name') || '供应商名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnCount',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_count') || '支数',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'spinningProcessName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_spinning_process_name') || '纺纱工艺',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'dyeingProcessName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_dyeing_process_name') || '染色工艺',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'spinningDate',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_spinning_date') || '纺纱时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'kgPrice',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_kg_price') || '单价',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnUnit',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_yarn_unit') || '单位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'moq',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_moq') || '起订量',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'yarnStatus',
    align: 'center',
    width: 150,
    title: this.$l('table_label_status') || '有效状态',
    slots: {default: 'status'},
    filters: [
      {label: '有效', value: 'Y'},
      {label: '无效', value: 'N'},
    ],
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
